import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { PersonalizationEngineState } from '../models'
import { getFavoriteGamesThunk } from '../thunks'

export const getFavoriteGamesExtraReducer = (
  builder: ActionReducerMapBuilder<PersonalizationEngineState>,
) => {
  builder.addCase(getFavoriteGamesThunk.pending, (state) => {
    state.isLoadingFavoriteGames = true
  })
  builder.addCase(getFavoriteGamesThunk.fulfilled, (state, { payload }) => {
    const { docs, ...pagination } = payload
    state.favoriteGames = (docs || []).map((doc: any) => ({
      ...doc,
      name: doc.game,
    }))
    state.pagination = pagination
    state.isLoadingFavoriteGames = false
  })
}
